var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "5px",
    viewBox: "0 0 9 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "932D5D9B-05A8-412F-BB4B-FAE9292E8EC4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-Page---",
    transform: "translate(-1395.000000, -19.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(1356.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "next-(2)",
    transform: "translate(43.500000, 15.500000) rotate(90.000000) translate(-43.500000, -15.500000) translate(41.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.86724757,4.17878765 L0.783542544,0.132857463 C0.604352295,-0.0442858211 0.314035435,-0.0442858211 0.134392686,0.132857463 C-0.044797562,0.310000747 -0.044797562,0.597727782 0.134392686,0.774871067 L3.89418268,4.49977577 L0.134845187,8.22468047 C-0.0443450614,8.40182375 -0.0443450614,8.68955079 0.134845187,8.86714254 C0.314035435,9.04428582 0.604804796,9.04428582 0.783995044,8.86714254 L4.86770007,4.82121235 C5.04417532,4.64590029 5.04417532,4.35365124 4.86724757,4.17878765 Z",
    id: "Chevron_Right_1_"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlack);
export default __webpack_public_path__ + "static/media/arrow-down-black.aef8975475f621c67d90210ae3fc5945.svg";
export { ForwardRef as ReactComponent };